import FacebookIcon from "../../assets/images/icons/facebook.webp";
import InstagramIcon from "../../assets/images/icons/instagram.webp";
import LinkedInIcon from "../../assets/images/icons/linkedin.webp";
import WechatIcon from "../../assets/images/icons/wechat.webp";
import WhatsappIcon from "../../assets/images/icons/whatsapp.webp";

export const SocialsStore = [
  { icon: LinkedInIcon, label: "LinkedIn", href: "#" },
  { icon: WechatIcon, label: "WeChat", href: "#" },
  { icon: WhatsappIcon, label: "WhatsApp", href: "#" },
  { icon: FacebookIcon, label: "Facebook", href: "#" },
  { icon: InstagramIcon, label: "Instagram", href: "#" },
];
